var _path, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVans(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 20.511,
    viewBox: "0 0 60 20.511",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h60v20.511H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "scale(.1917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.08 52.23h-18.06c-1.75-4.44-3.71-7.89-13.83-7.89-7 0-10 2.88-10 5.77 0 3.16 2.49 5.82 10.2 7.53L289.75 62c10.71 2.86 15.9 11.36 15.9 20.34 0 5-1.08 11-5.82 16-3.54 3.69-8.9 8.56-26.67 8.56-24.44 0-32.47-15.45-32.47-24.78h19c1.87 6.82 6.55 9.41 15.81 9.41 6.42 0 11.93-2.29 11.93-7.2 0-4.67-4-6.43-9.15-7.84L265.35 73c-6.23-1.9-11.44-3.42-15.12-6.53-9.63-8.16-8.93-22.89 1.54-30.55 5.8-4.24 11.74-6.45 21.17-6.45 11.08 0 17.41 3.16 22.39 6.6 4.42 3 9.67 10.38 9.67 16.2M0 .04c.15.65 37.8 106 37.8 106h22.47l34.61-87.7h215L311.51.01H78.41L49.69 72.68 23.88 0H.05m185.83 68.09l28.06 37.89h17.56V31.05h-20.22V71.8l-25.4-40.75h-19.4v74.93h19.4zm126.35 34a4 4 0 10-4 4 4 4 0 004.05-4zm-.46 0a3.52 3.52 0 11-3.51-3.53 3.502 3.502 0 013.56 3.53zm-1.62-.83a1.43 1.43 0 00-1.66-1.4h-1.88v4.24h.94v-1.36h.74l.9 1.36h1.09l-1-1.52a1.32 1.32 0 00.92-1.32zm-.95.05a.622.622 0 01-.72.62h-.94v-1.24h.91a.63.63 0 01.8.63zm-230.32 4.67h21.55l4-11.72h28.53l4.13 11.72h21.22l-27.16-74.93H108.3zm31.6-25.28l8.35-24.91 8.24 24.91h-16.64z",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVans);
export default __webpack_public_path__ + "static/media/vans.0a7dc2d395ae438fd01b7ef70d6a7dc6.svg";
export { ForwardRef as ReactComponent };